// Raises a popover="manual" layer into the browser's top layer, above every stacking context, transform and clip the
// page puts around it. A browser without popovers - or a layer that is already raised or left the page - keeps it
// where it is: the stylesheets show such layers in place there, as fixed popups.
// Shared by the calendar module (window.DwsCalendarShowPopupLayer: DwsCalendar's popup layer, DwsScheduler's prompt
// layer) and by whatever publishes DwsShowPopoverLayer (DwsBanner, a full-screen DwsOverlay), which used to call
// DwsCalendarShowPopupLayer synchronously - import this instead, so neither module loads the other.
export function showPopupLayer(element: HTMLElement | null): void {
    if (!element || typeof element.showPopover !== 'function') {
        return;
    }

    try {
        if (!element.matches(':popover-open')) {
            element.showPopover();
        }
    } catch (error) {
        // Nothing to do: the popup still works in place.
    }
}
